import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-recompose';
import includes from 'lodash/includes';
import { Link, withRouter } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';
import Menu from '../Menu';
import PageTitle from '../PageTitle';
import { active } from './styles.css';
import UnauthorizedPage from '../../containers/UnauthorizedPage';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';
import {
  CAMINO_EVENTS_HE,
  CAMINO_SUBSCRIPTION,
  REP_VISITS_SUBSCRIPTION,
} from '../../containers/Authorization/constants';
import { withEnabledFeatures } from '../../utils/features';

const messages = defineMessages({
  viewEvents: {
    id: 'collegeevents.view.events',
    defaultMessage: 'Events',
  },
  viewFilters: {
    id: 'collegeevents.view.filters',
    defaultMessage: 'Filters',
  },
});

function getEventTabActiveClass(router) {
  return router.location.pathname.includes('/college-events/view-events/') ? active : '';
}

const CollegeEventsFrame = (props) => (
  <div styleName="container">
    <PageTitle title="Events" category="Presence" />
    <nav aria-label="Events Menu">
      <Menu stackable as="ul" pointing secondary size="huge" styleName="menu">
        <Menu.Item as="li" link styleName="menu-item">
          <Link
            to="/college-events/view-events/published"
            styleName="menu-link"
            className={getEventTabActiveClass(props.router)}
            activeClassName={active}
            data-cy="amevents-events-link"
          >
            <FormattedMessage {...messages.viewEvents} />
          </Link>
        </Menu.Item>
        {props.showFilters && (
          <Menu.Item as="li" link styleName="menu-item">
            <Link
              to="/college-events/view-filters"
              styleName="menu-link"
              activeClassName={active}
              data-cy="college-events-filters-link"
            >
              <FormattedMessage {...messages.viewFilters} />
            </Link>
          </Menu.Item>
        )}
      </Menu>
    </nav>
    <main aria-labelledby="pageTitle" styleName="content" id="content">
      {props.children}
    </main>
  </div>
);

CollegeEventsFrame.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.object.isRequired,
  }).isRequired,
  children: PropTypes.node,
  showFilters: PropTypes.bool,
};

const CollegeEvents = (props) => {
  const subscriptions = props.enabledFeatures.includes(CAMINO_EVENTS_HE) ?
    [REP_VISITS_SUBSCRIPTION, CAMINO_SUBSCRIPTION] :
    [REP_VISITS_SUBSCRIPTION];
  const hasSubscription =
    props.heAccount &&
    subscriptions.some((sub) =>
      includes(props.heAccount.activeSubscriptions, sub));
  const isFilterRoute = props.location.pathname.includes('/view-filters');
  const showFilters = props.enabledFeatures.includes(CAMINO_EVENTS_HE) ?
    props.heAccount.activeSubscriptions.includes(REP_VISITS_SUBSCRIPTION) :
    true;
  const showFrame = isFilterRoute && !showFilters ? false : hasSubscription;

  if (showFrame) {
    return <CollegeEventsFrame {...props} showFilters={showFilters} />;
  }

  return <UnauthorizedPage />;
};
CollegeEvents.propTypes = {
  heAccount: PropTypes.object,
  enabledFeatures: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

export default compose(
  withEnabledFeatures,
  withHEAccountSubscriptions,
  withRouter,
)(CollegeEvents);
